import { css } from 'styled-components'

// PADDING & MARGIN SIZES
export const size_0 = '0'
export const size_2 = '0.5rem'
export const size_4 = '1rem'
export const size_6 = '1.5rem'
export const size_8 = '2rem'

// SCREEN SIZES
export const screen_sm = '576px'
export const screen_md = '768px'
export const screen_lg = '992px'
export const screen_xl = '1200px'

// TEXT SIZES
export const text_xs = `font-size: .7rem`
export const text_sm = `font-size: .95rem`
export const text_base = `font-size: 1.1rem`
export const text_md = `font-size: 1.3rem`
export const text_lg = `font-size: 1.55rem`
export const text_xl = `font-size: 1.8rem`
export const text_xxl = `font-size: 2.5rem`

// TEXT THICKNESS
export const text_thinner = `font-weight: 200`
export const text_thin = `font-weight: 300`
export const text_normal = `font-weight: 1000`
export const text_bold = `font-weight: bold`

// OTHER
export const backgroundCoverImg = `
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`
export const displayText = `
  line-height: 1.25;
  letter-spacing: 0.05em;
  ${text_thinner};
  ${text_sm};
`
export const centredFlex = `
  display: flex;
  justify-content: center;
  align-items: center;
`

// MOBILE FIRST RESPONSIVE
export const media = {
  screen_sm: (...args) => css`
    @media (min-width: ${screen_sm}) {
      ${css(...args)};
    }
  `,
  screen_md: (...args) => css`
    @media (min-width: ${screen_md}) {
      ${css(...args)};
    }
  `,
  screen_lg: (...args) => css`
    @media (min-width: ${screen_lg}) {
      ${css(...args)};
    }
  `,
  screen_xl: (...args) => css`
    @media (min-width: ${screen_xl}) {
      ${css(...args)};
    }
  `,
}



// WEBPACK FOOTER //
// ./src/module/style-variables.js